import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo-devloader.svg'


const _withScopeId = n => (_pushScopeId("data-v-16736cff"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "no-display" }, "Dev'loader", -1))
const _hoisted_2 = { id: "WebsiteLogo" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("figcaption", null, "Espace Client", -1))
const _hoisted_4 = {
  key: 0,
  id: "MainMenu",
  class: "init-fadeout"
}
const _hoisted_5 = { class: "side-btn-container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Espace clients", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Se déconnecter", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Me contacter", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    id: "AppHeader",
    class: "no-text-selection",
    style: _normalizeStyle(_ctx.CSSVars)
  }, [
    _hoisted_1,
    _createElementVNode("figure", _hoisted_2, [
      _createElementVNode("img", {
        class: "pointered",
        src: _imports_0,
        alt: "Logo Dev'loader",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.GoTo('/redirect/www')))
      }),
      _hoisted_3
    ]),
    (_ctx.IsAuthenticated)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_4, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
              return (_openBlock(), _createElementBlock("li", {
                key: link.to
              }, [
                (link.icon)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: link.to
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, {
                          icon: link.icon.use()
                        }, null, 8, ["icon"]),
                        _createElementVNode("span", null, _toDisplayString(link.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: link.to
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(link.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("aside", _hoisted_5, [
      (!_ctx.IsAuthenticated)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            id: "SigninButton",
            class: "fixed-btn init-fadein no-text-selection fadein",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.GoTo('/signin')))
          }, [
            _createElementVNode("span", null, [
              _createVNode(_component_font_awesome_icon, {
                icon: _ctx.icons.signin.use()
              }, null, 8, ["icon"])
            ]),
            _hoisted_6
          ]))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            id: "SignoutButton",
            class: "fixed-btn init-fadein no-text-selection fadein",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.GoTo('/signout')))
          }, [
            _createElementVNode("span", null, [
              _createVNode(_component_font_awesome_icon, {
                icon: _ctx.icons.signout.use()
              }, null, 8, ["icon"])
            ]),
            _hoisted_7
          ])),
      _createElementVNode("button", {
        id: "ContactButton",
        class: "fixed-btn init-fadein no-text-selection fadein",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.GoTo('/redirect/contact')))
      }, [
        _createElementVNode("span", null, [
          _createVNode(_component_font_awesome_icon, {
            icon: _ctx.icons.contact.use()
          }, null, 8, ["icon"])
        ]),
        _hoisted_8
      ])
    ])
  ], 4))
}